/**
 * Tells if a semantic search text is in use. A facet URL such as `/uk/semanticQuery`
 * sets the value to "true", which is no text, so it does not count.
 * Analytics gets only this flag, never the text the user typed.
 */
export const isSemanticSearchUsed = (value: unknown): boolean =>
  typeof value === 'string' && value.trim() !== '' && value !== 'true';
